/* PD Produktrække: the feed's cards on the front page. Picked products are rendered by Liquid;
   "recently viewed" is built here from localStorage (pd_recent, written on product pages) via
   /products/<handle>.js. Four cards visible, arrows scroll one page, quantity + add to cart work. */
(function () {
  var KEY = "pd_recent";
  /* The AMOUNTS from /products/<handle>.js are already the visitor's market price — verified
     against Liquid in the EUR market: both say 44.95. Only the label was wrong: this took an
     optional `fmt` argument, every caller omitted it, so it always fell through to " kr." and a
     Swedish or Austrian shopper saw their own amount labelled in kroner.
     The currency comes from `cart.currency.iso_code` via [data-pd-ctx], which follows whatever
     market the customer has selected. */
  var CCY = (function () {
    var ctx = document.querySelector("[data-pd-ctx]");
    return (ctx && ctx.dataset.currency)
      || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active)
      || "DKK";
  })();
  function money(cents) {
    var n = Number(cents) / 100;
    if (!isFinite(n)) return "";
    if (window.pdFormatMoney) return window.pdFormatMoney(n);   // the product page's format (theme.liquid)
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "da-DK", {
        style: "currency", currency: CCY,
      }).format(n);
    } catch (e) {
      return n.toFixed(2) + " " + CCY;
    }
  }
  /* The variant a card should advertise: the cheapest one the customer can actually buy. On an
     outlet product that is the discounted unit — the full-price variant comes first in the JSON,
     which is why these cards showed no offer at all on a product that was 30% off. */
  function pick(p) {
    var vs = p.variants || [];
    var best = vs[0] || {};
    for (var i = 0; i < vs.length; i++) {
      if (!vs[i].available) continue;
      if (!best.available || vs[i].price < best.price) best = vs[i];
    }
    return best;
  }
  function isOutlet(p) {
    return (p.tags || []).some(function (t) { return String(t).toLowerCase() === "outlet"; });
  }
  var CHECK = '<svg viewBox="0 0 24 24" width="1em" height="1em" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20 6 9 17l-5-5"/></svg>';
  /* Stock on cards built in JS ("Senest sete varer" here, "Du mangler måske også" in pd-related.js).
     Both said "På lager" whenever Shopify's `available` was true — and that is true for everything sold
     on backorder (merchant 2026-10-12). A purchasable card now renders an empty
     stock line marked data-pd-stock-handle, and this fills it from /api/storefront/product-stock with the
     feed's rule: in stock / "På lager d. <date>" / "I restordre" / out. No answer, no claim: the line stays
     empty rather than guess. */
  function stockLine(handle, available, L) {
    if (!available) return '<span class="pd-stock pd-stock--out"><i></i>' + String(L.outStock || "").replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }) + "</span>";
    return '<span class="pd-stock" data-pd-stock-handle="' + String(handle || "").replace(/[^a-z0-9-]/gi, "") + '"><i></i>&nbsp;</span>';
  }
  function liveStock(root) {
    var els = Array.prototype.slice.call(root.querySelectorAll("[data-pd-stock-handle]"));
    if (!els.length) return;
    var ctx = document.querySelector("[data-pd-ctx]");
    var shop = root.dataset.shop || (ctx && ctx.dataset.shop);
    if (!shop) return;
    var handles = [];
    els.forEach(function (el) { var h = el.dataset.pdStockHandle; if (h && handles.indexOf(h) < 0) handles.push(h); });
    var base = (root.dataset.apiBase || "https://pd-garage.fly.dev").replace(/\/$/, "");
    var url = base + "/api/storefront/product-stock?shop=" + encodeURIComponent(shop) + "&handles=" + encodeURIComponent(handles.slice(0, 24).join(","))
      + (ctx && ctx.dataset.country ? "&country=" + encodeURIComponent(ctx.dataset.country) : "");
    var T = function (k, d) { return root.dataset[k] || d; };
    fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (data) {
      var items = (data && data.items) || {};
      els.forEach(function (el) {
        var s = items[el.dataset.pdStockHandle];
        if (!s || !el.isConnected) return;
        el.removeAttribute("data-pd-stock-handle");
        el.className = "pd-stock pd-stock--" + (s.state === "in" || s.state === "backorder" ? s.state : "out");
        var text = s.state === "in" ? T("labelInstock", "In stock")
          : s.state === "backorder" ? (s.eta ? T("labelBackinstock", "Back in stock:") : T("labelInbackorder", "In backorder"))
          : T("labelOutstock", "Out of stock");
        el.innerHTML = "<i></i>";
        el.appendChild(document.createTextNode(text));
        if (s.state === "backorder" && s.eta) {
          var d = document.createElement("span"); d.className = "pd-eta"; d.textContent = s.eta;   // its own span: the date's hyphens must not wrap it
          el.appendChild(document.createTextNode(" ")); el.appendChild(d);
        }
        if (s.state === "out") { var b = el.closest(".pd-card") && el.closest(".pd-card").querySelector("[data-pd-add]"); if (b) b.disabled = true; }
      });
    }).catch(function () {});
  }
  /* Add + open the drawer the way the feed's cards do (fitment-widgets.js, themeAddToCart): the
     theme's own product form posts with bundled `sections`, publishes cartUpdate so the drawer
     re-renders its line items, then show()s it. The handler here used to fire a bare
     cart:refresh, so the count changed but the drawer stayed shut and the button never said
     "Tilføjet" — merchant 2026-09-23: the collection cards did, the front-page cards did not. */
  function addToCart(variantId, qty, focusEl) {
    var drawer = document.querySelector("cart-drawer"), FT = window.FoxTheme;
    if (drawer && FT && FT.pubsub && FT.routes && FT.pubsub.PUB_SUB_EVENTS) {
      var sections = [];
      try { document.documentElement.dispatchEvent(new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections: sections } })); } catch (e) {}
      var fd = new FormData();
      fd.append("id", String(variantId)); fd.append("quantity", String(qty));
      if (sections.length) fd.append("sections", sections.join(","));
      fd.append("sections_url", location.pathname);
      return fetch(FT.routes.cart_add_url || "/cart/add", { method: "POST", headers: { "X-Requested-With": "XMLHttpRequest", Accept: "application/json" }, body: fd })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (parsed) { if (!r.ok || parsed.status) throw new Error("cart add failed"); return parsed; }); })
        .then(function (parsed) {
          return fetch(FT.routes.cart_url || "/cart.js", { headers: { Accept: "application/json" } })
            .then(function (r) { return r.json(); })
            .then(function (cart) { cart.sections = parsed.sections; FT.pubsub.publish(FT.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart, source: "pd-prow" }); }, function () {})
            .then(function () {
              try { document.dispatchEvent(new CustomEvent("product-ajax:added", { detail: { product: parsed } })); } catch (e) {}
              if (typeof drawer.show === "function" && !drawer.open) { try { drawer.show(focusEl || null); } catch (e) {} }
            });
        });
    }
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }) })
      .then(function (r) { if (!r.ok) throw new Error("cart/add " + r.status); document.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true, detail: { open: true } })); });
  }
  function card(p, L) {
    var v = pick(p);
    // An outlet-identical product offers no real choice, so the card adds to cart like any single.
    var multi = (p.variants || []).length > 1
      && !(p.tags || []).some(function (t) { return String(t).toLowerCase() === "outlet-identical"; });
    var off = v.compare_at_price && v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
    var img = p.featured_image ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, "_480x$1$2") + '" alt="" loading="lazy">' : '<div class="pd-thumb__art--placeholder"></div>';
    var buy = multi
      ? '<a href="' + p.url + '" class="pd-add pd-add--block pd-add--select"><span>' + L.select + "</span></a>"
      : '<div class="pd-qty" data-pd-qty><button type="button" class="pd-qty__btn" data-pd-qty-dec aria-label="−">−</button><input class="pd-qty__in" type="number" inputmode="numeric" min="1" max="99" value="1"><button type="button" class="pd-qty__btn" data-pd-qty-inc aria-label="+">+</button></div>'
        + '<button type="button" class="pd-add pd-add--block" data-pd-add="' + v.id + '"' + (v.available ? "" : " disabled") + "><span>" + L.add + "</span></button>";
    return '<li class="pd-prow__item"><article class="pd-card pd-card--clean">'
      + '<a href="' + p.url + '" class="pd-thumb"><div class="pd-thumb__art">' + img + "</div>"
      + '<div class="pd-overlays"><span></span>' + (off > 0 ? '<span class="pd-sale">-' + off + "%</span>" : "<span></span>") + "</div>"
      + (isOutlet(p)
          ? '<div class="pd-tag-bar"><span class="pd-tag-row"></span><span class="pd-outlet">' + L.outlet
            + (off > 0 ? " – " + L.save + " " + off + "%" : "") + "</span></div>"
          : "") + "</a>"
      + '<div class="pd-card__body"><a href="' + p.url + '"><h3 class="pd-name"></h3></a>'
      + (multi || !v.sku ? "" : '<span class="pd-sku"></span>')
      + stockLine(p.handle, p.available, L)
      + '<div class="pd-card__foot"><div class="pd-price">' + (off > 0 ? "<s>" + money(v.compare_at_price) + "</s>" : "")
      + "<strong>" + money(v.price) + "</strong></div></div>"
      + buy + "</div></article></li>";
  }
  function fill(li, p) {   // text via textContent: product titles are merchant data, never HTML
    var v = pick(p);
    li.querySelector(".pd-name").textContent = p.title || "";
    var sku = li.querySelector(".pd-sku"); if (sku) sku.textContent = v.sku || "";
  }
  function init(root) {
    if (root.dataset.pdProwInit) return; root.dataset.pdProwInit = "1";
    var track = root.querySelector("[data-pd-prow-track]");
    if (!track) return;
    var L = { add: root.dataset.labelAdd || "Add to cart", added: root.dataset.labelAdded || "Added", select: root.dataset.labelSelect || "Select variant", inStock: root.dataset.labelInstock || "In stock", outStock: root.dataset.labelOutstock || "Out of stock", vat: root.dataset.labelVat || "incl. VAT", outlet: root.dataset.labelOutlet || "Outlet", save: root.dataset.labelSave || "save" };
    function wire() {
      root.querySelectorAll("[data-pd-qty]").forEach(function (q) {
        if (q._pd) return; q._pd = true;
        var input = q.querySelector(".pd-qty__in");
        q.querySelector("[data-pd-qty-dec]").addEventListener("click", function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
        q.querySelector("[data-pd-qty-inc]").addEventListener("click", function () { input.value = Math.min(99, (parseInt(input.value, 10) || 1) + 1); });
      });
      root.querySelectorAll("[data-pd-add]").forEach(function (b) {
        if (b._pd) return; b._pd = true;
        b.addEventListener("click", function () {
          if (b.disabled) return;
          var card = b.closest(".pd-card"), input = card.querySelector(".pd-qty__in");
          var original = b.innerHTML;
          b.disabled = true; b.classList.add("is-loading");
          addToCart(Number(b.dataset.pdAdd), parseInt(input && input.value, 10) || 1, b)
            .then(function () {
              b.classList.remove("is-loading"); b.classList.add("is-added");
              b.innerHTML = CHECK + "<span>" + L.added + "</span>";   // same confirmation as the feed's cards
              if (input) input.value = 1;
            }, function () { b.classList.remove("is-loading"); b.classList.add("is-error"); })
            .then(function () { setTimeout(function () { b.innerHTML = original; b.disabled = false; b.classList.remove("is-added", "is-error"); }, 1400); });
        });
      });
    }
    function sync() {
      var max = track.scrollWidth - track.clientWidth;
      var slack = 8;   /* scroll-snap can leave the track a pixel or two off zero */
      root.classList.toggle("is-start", track.scrollLeft <= slack);
      root.classList.toggle("is-end", max <= slack || track.scrollLeft >= max - slack);
    }
    var raf = 0; track.addEventListener("scroll", function () { if (raf) return; raf = requestAnimationFrame(function () { raf = 0; sync(); }); }, { passive: true });
    window.addEventListener("resize", sync);
    var page = function () { var it = track.querySelector(".pd-prow__item"); var gap = parseFloat(getComputedStyle(track).gap) || 0; return it ? (it.getBoundingClientRect().width + gap) * Math.max(1, Math.floor(track.clientWidth / (it.getBoundingClientRect().width + gap))) : track.clientWidth; };
    var nextBtn = root.querySelector("[data-pd-prow-next]"), prevBtn = root.querySelector("[data-pd-prow-prev]");
    if (nextBtn) nextBtn.addEventListener("click", function () { track.scrollBy({ left: page(), behavior: "smooth" }); });
    if (prevBtn) prevBtn.addEventListener("click", function () { track.scrollBy({ left: -page(), behavior: "smooth" }); });
    var resync = function () { sync(); requestAnimationFrame(sync); setTimeout(sync, 400); };   /* again once images have sized the track */
    root.querySelectorAll("img").forEach(function (im) { if (!im.complete) im.addEventListener("load", sync, { once: true }); });
    if (root.dataset.source !== "recent") { wire(); resync(); liveStock(root); return; }   // Liquid rows have no placeholders; pd-related's do

    var handles = [];
    try { handles = JSON.parse(localStorage.getItem(KEY) || "[]"); } catch (e) {}
    handles = handles.filter(Boolean).slice(0, parseInt(root.dataset.limit, 10) || 8);
    if (!handles.length) return;   // nothing seen yet: the whole section stays hidden
    Promise.all(handles.map(function (h) { return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); }))
      .then(function (list) {
        var ok = list.filter(Boolean);
        if (!ok.length) return;
        track.innerHTML = ok.map(function (p) { return card(p, L); }).join("");
        Array.prototype.forEach.call(track.children, function (li, i) { fill(li, ok[i]); });
        root.hidden = false; wire(); resync(); liveStock(root);
        track.querySelectorAll("img").forEach(function (im) { if (!im.complete) im.addEventListener("load", sync, { once: true }); });
      });
  }
  /* A real row has a track. `data-pd-prow` is ALSO on the product page's accordion row buttons
     (sections/pd-product-rows.liquid), and initialising one of those threw on the first missing
     nav button — which aborted this whole script on every product page. */
  function all(scope) {
    (scope || document).querySelectorAll("[data-pd-prow]").forEach(function (el) {
      if (el.querySelector("[data-pd-prow-track]")) init(el);
    });
  }
  /* Exposed BEFORE all() runs: a throw in one row must not cost every other widget the hook.
     Related products (pd-related.js) renders the same cards from our own API and reuses the
     carousel, quantity steppers and add-to-cart that already live here. init() guards against
     double-binding. */
  window.PdProductRow = { mount: init, stockLine: stockLine };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { all(); }); else all();
  document.addEventListener("pd:navigated", function () { all(); });
  document.addEventListener("shopify:section:load", function (e) { all(e.target); });
})();
